<template>
  <div class="table">
    <div class="tr th">
      <span>Information</span>
      <span
        v-for="(item, index) in form"
        :key="index">Driver {{ index+1 }}</span>
    </div>
    <div class="tr">
      <span>Name</span>
      <span
        v-for="(item, index) in form"
        :key="index">{{ item.nm_drvr_name }}</span>
    </div>
    <div class="tr">
      <span>Age</span>
      <span
        v-for="(item, index) in form"
        :key="index">{{ getGlobalOptionName('motor_trade_age', item.nm_drvr_age) }}</span>
    </div>
    <div class="tr">
      <span>Years of driving experience</span>
      <span
        v-for="(item, index) in form"
        :key="index">
        {{ getGlobalOptionName('motor_trade_drvr_exp', item.nm_drvr_exp) }}
      </span>
    </div>
    <div class="tr">
      <span>Relationship to the Insured</span>
      <span
        v-for="(item, index) in form"
        :key="index">
        {{ getGlobalOptionName('relationship_insured', item.nm_drvr_rel_id ) }}
      </span>
    </div>
    <div class="tr">
      <span>Have been prosecuted or been deducted more than five driving offence points in total or had driving license disqualified by a court in the last two years?</span>
      <span
        v-for="(item, index) in form"
        :key="index">
        {{ getOptionName('yesNo2Options', item.nm_drvr_ded_ind) | formatYesNo }}
      </span>
    </div>
    <div class="tr">
      <span>Have suffered/been suffering from heart diseases, diabetes and epilepsy; defective vision or hearing; or physical and mental infirmities?</span>
      <span
        v-for="(item, index) in form"
        :key="index">
        {{ getOptionName('yesNo2Options', item.nm_drvr_ill_ind) | formatYesNo }}
      </span>
    </div>
    <div class="tr">
      <span>Have had any motor insurance refused?</span>
      <span
        v-for="(item, index) in form"
        :key="index">
        {{ getOptionName('yesNo2Options', item.nm_drvr_refus_ind) | formatYesNo }}
      </span>
    </div>
    <div class="tr">
      <span>Have had any accidents, losses or claims in the past three years or are under any police enquiries and prosecutions?</span>
      <span
        v-for="(item, index) in form"
        :key="index">
        {{ getOptionName('yesNo2Options', item.nm_drvr_accid_ind) | formatYesNo }}
      </span>
    </div>
    <div class="tr">
      <span>Have made any motor claims against other insurance companies in the past three years?</span>
      <span
        v-for="(item, index) in form"
        :key="index">
        {{ getOptionName('yesNo2Options', item.nm_drvr_claim_ind) | formatYesNo }}
      </span>
    </div>
  </div>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'DriversInfoMotor',
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
// .table {
//     .tr {
//         display: flex;
//         span:first-child {
//             width: 25%!important;
//         }
//     }
// }
</style>